module.exports = __webpack_public_path__ + "img/company_2.5166ba51.png";